<!-- The search toolbar -->
<div class="search-toolbar-container">
	@if (showFilterToggle) {
		<div class="filter-toggle-container">
			<app-data-set-action-button
				svgIcon="sl-filter"
				label="Filters"
				i18n-label="@@dataSetSearch-Filters"
				(click)="toggleFilterPanel()"
				data-automation-id="data-set-search-toggle-filters-button"
				[selected]="filterOverlayVisible"
			></app-data-set-action-button>
		</div>
	}
	@if (currentlySearching) {
		<div class="mat-caption filter-search-bar">
			<mat-icon
				class="data-set-search-input-icon"
				[ngClass]="{ primary: !filterOverlayVisible, 'primary-disabled': filterOverlayVisible }"
				style="margin-right: 8px"
				>search
			</mat-icon>
			<input
				#searchInput
				class="data-set-search-input"
				[ngClass]="{ 'primary-disabled': filterOverlayVisible }"
				style="flex: 1"
				matInput
				placeholder="{{ placeholder }}"
				[disabled]="filterOverlayVisible"
				(keydown.enter)="applyDefaultFilter()"
				data-automation-id="data-set-search-input"
			/>
		</div>
	}

	@if (!currentlySearching) {
		<div class="chip-list-container">
			<mat-chip-set>
				@for (filter of filterItems; track filter.name) {
					<mat-chip class="filter-chip">
						<span style="font-weight: lighter">{{ filter.label }}:&nbsp;</span>
						<span style="font-weight: bold">{{ getDisplayValue(filter) | accessDateFilter }}</span>
						<span
							class="removeIconCenterHack"
							style="margin-left: 6px; cursor: pointer"
							(click)="removeFilter(filter)"
							(keydown.enter)="removeFilter(filter)"
							(keydown.space)="removeFilter(filter)"
							tabindex="0"
							role="button"
							[attr.aria-label]="getRemoveFilterAriaLabel(filter)"
							[attr.data-automation-id]="getDisplayValue(filter) + '-chip'"
						>
							<mat-icon class="filter-chip-remove-icon">close</mat-icon>
						</span>
					</mat-chip>
				}
			</mat-chip-set>
			<div>
				<button
					mat-button
					class="data-set-action-button-normal data-set-action-button-clear"
					style="margin-left: 4px; height: 30px !important; overflow: hidden; margin-top: 4px; width: 85px"
					(click)="removeAllFilters()"
					i18n="@@dataSetSearch-clearAll"
					data-automation-id="data-set-search-clear-all-button"
				>
					Clear All
				</button>
			</div>
		</div>
	}
</div>

<!-- The filter overlay -->
<ng-template #filterTemplate>
	<div class="filter-panel">
		<div class="mat-elevation-z1">
			<div class="filter-content">
				<ng-content></ng-content>
			</div>
			<div class="filter-divider"></div>
			<div class="filter-action-row">
				<button
					mat-button
					class="secondary-button"
					(click)="closeFilterPanel()"
					i18n="@@dataSetSearch-cancel"
					data-automation-id="data-set-search-cancel-button"
				>
					Cancel
				</button>
				<button
					mat-button
					class="primary-button"
					(click)="applyFilters()"
					i18n="@@dataSetSearch-apply"
					data-automation-id="data-set-search-apply-button"
				>
					Apply
				</button>
			</div>
		</div>
	</div>
</ng-template>
